import React from 'react';
import { Link } from 'react-router-dom';

const PropertyCard = ({ property }) => {
  return (
    <div style={styles.card}>
      <div 
        style={{ 
          ...styles.image, 
          backgroundImage: `url(${property.images[0]})` 
        }}
      ></div>
      
      <div style={styles.content}>
        <div style={styles.price}>${property.price.toLocaleString()}</div>
        <h3 style={styles.title}>{property.title}</h3>
        <p style={styles.location}>{property.location}</p>
        
        <div style={styles.details}>
          <span>{property.bedrooms} beds</span>
          <span>{property.bathrooms} baths</span>
          <span>{property.area} m²</span>
        </div>
        
        <Link to={`/nekretnina/${property.id}`} style={styles.link}>
          View Details
        </Link>
      </div>
    </div>
  );
};

const styles = {
  card: {
    backgroundColor: 'white',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s, box-shadow 0.3s',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  image: {
    height: '200px',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  content: {
    padding: '1.5rem',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  price: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#4a6fa5',
    marginBottom: '0.5rem'
  },
  title: {
    fontSize: '1.25rem',
    marginBottom: '0.5rem'
  },
  location: {
    color: '#666',
    marginBottom: '1rem'
  },
  details: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '1rem',
    color: '#555'
  },
  link: {
    marginTop: 'auto',
    textAlign: 'center',
    display: 'block',
    padding: '10px',
    backgroundColor: '#4a6fa5',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '4px',
    fontWeight: '600',
    transition: 'background-color 0.3s'
  }
};

export default PropertyCard;